import bundleStore from '../../../store/bundleStore';
import React, {useContext, useEffect} from 'react';
import ConfirmData from "./ConfirmHeader";
import UiButton from "../../../components/button";
import {Box} from "../../../components/box";
import {SpaceHandlerContext} from "../../../contexts/spaceContext";
import numStore from "../../../store/numStore";
import priceStore from "../../../store/priceStore";
import {observer} from "mobx-react";
import {useNavigate} from "react-router-dom";
import {UserDispatchContext} from "../../../contexts/userContext";

const Confirm = observer(({children, setPage, setReValid, setRead, setRead2}) => {

    const [dispatch, nextHandler, loadStart, loadFinish, delDispatch] = useContext(SpaceHandlerContext)
    const [,,,delValueHandler] = useContext(UserDispatchContext)

    let navigate = useNavigate()
    let params = new URLSearchParams(window?.location?.search)

    useEffect(() => {
        if(params.get('imp_success') === 'false') {
            pageHandler()
        }
    }, [])

    //초기화
    function pageHandler() {
        bundleStore.reset()
        priceStore.initValue()
        numStore.initValue()
        delValueHandler()
        delDispatch('delRoom')
        delDispatch('delDate')
        setReValid(false)
        setRead(false)
        setRead2(false)
        localStorage.removeItem('userToken')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('shopMobileInfo')
        localStorage.removeItem('roomNo')
        localStorage.removeItem('roomInfo')
        console.clear()
        setPage('room')
        navigate('/')
    }

    return (
        <div className='confirm'>
            {children}
            <Box className='home_btn common_btn_wrap'>
                <UiButton
                    text={'홈으로'}
                    type='button'
                    onClick={pageHandler}/>
            </Box>
        </div>
    );
});

Confirm.Data = ConfirmData;

export default Confirm;
